import { createSlice } from '@reduxjs/toolkit';

const initialFormSignatureState = {
    signatureModalShow: false,
    pageIndex: null,
    childIndex: null
}

const formSignatureSlice = createSlice({
    name: 'formSignature',
    initialState: initialFormSignatureState,
    reducers: {
        showFormSignatureModal (state, actions) {
            state.pageIndex = actions.payload.pageIndex;
            state.childIndex = actions.payload.childIndex;
            state.signatureModalShow = true;
        },
        closeFormSignatureModal (state) {
            state.signatureModalShow = false;
            state.pageIndex = null;
            state.childIndex = null;
        }
    }
})

export const formSignatureActions = formSignatureSlice.actions;
export default formSignatureSlice;